define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "hypo_elements/Containers/Klappmodul/Klappmodul", "hypo_elements/Typescripts/QueryStringGenerator/ScrollToHash/ScrollToHash"], function (require, exports, Configuration_1, Klappmodul_1, ScrollToHash_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var queryhash = window.location.hash.substring(1);
        if (queryhash.length > 0) {
            var hash = 'c' + queryhash.charAt(0).toUpperCase() + queryhash.slice(1);
            var klappmodul = $('#' + hash);
            if (klappmodul != undefined) {
                (0, Klappmodul_1.openKlappmodulFromExternalTrigger)(klappmodul);
                (0, ScrollToHash_1.scrollToHash)(hash, Configuration_1.configuration.stickyHeaderHeight * -2);
            }
        }
    });
});
